import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { setLoading, setUserDetails, signout } from "../feature/authSlice";
import {store} from '../feature/store'
import * as CryptoJS from "crypto-js";
import { decryptStringBase64, encryptStringBase64, normalizeToJwtString } from "./cryptohelpers";
import { toast } from 'react-toastify';

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const genericUrl="https://apigwvendortopay.co.in/GenericApi/api/v2.0/"

export const errorGet = (error) => {
  return error
}
// Function to check and refresh access token if expired
async function manageAccessToken() {
  try {
    const enc = localStorage.getItem("access_token");
    if (!enc) {
      console.warn("No access token in localStorage");
      return null;
    }
    
    const decrypted = decryptStringBase64(enc);
    if (!decrypted) {
      console.error("Token decryption failed");
      logout(store, signout);
      return null;
    }
    
    const accessToken = normalizeToJwtString(decrypted);
    
    // Validate JWT format
    if (!accessToken || accessToken.split('.').length !== 3) {
      console.error("Invalid JWT format after decryption");
      logout(store, signout);
      return null;
    }
    
    let decodedToken;
    try {
      decodedToken = jwtDecode(accessToken);
    } catch (error) {
      console.error("JWT decode failed:", error.message);
      logout(store, signout);
      return null;
    }
    
    let currentDate = new Date();
    let tokenExpirationDate = new Date(decodedToken.exp * 1000);
    let tenMinutesInMillis = 10 * 60 * 1000;
    
    // Token is more than 10 minutes past expiration
    if (currentDate.getTime() > tokenExpirationDate.getTime() + tenMinutesInMillis) {
      // console.log("Token expired beyond grace period - logging out");
      logout(store, signout);
      return null;
    }
    
    // Token expired or within grace period - refresh
    if (currentDate.getTime() >= tokenExpirationDate.getTime()) {
      // console.log("Token expired - attempting refresh");
      try {
        return await refreshAccessToken();
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        logout(store, signout);
        return null;
      }
    }
    
    return accessToken;
  } catch (error) {
    console.error("manageAccessToken error:", error);
    logout(store, signout);
    return null;
  }
}


const logout = (store, dispatchAction) => {
      store.dispatch(dispatchAction());
      store.dispatch(setLoading(false))
      store.dispatch(setUserDetails(null))
      localStorage.removeItem("Ok");
  // customDispatch(signout(false));
  // window.location.replace('/login');
  // Add any additional logout logic here (e.g., redirect to login page)
  // console.log("Logged out due to token expiration");
};


// Function to refresh access token
async function refreshAccessToken() {
  try {
    let url = process.env.REACT_APP_BASE_URL + "Identity/api/Account/RefreshToken";
        const stored = localStorage.getItem("access_token");
    const decrypted = decryptStringBase64(stored);
    const accessTokenPlain = normalizeToJwtString(decrypted);
    const response = await axios.post(url, {
      AccessToken: accessTokenPlain,
      RefreshToken: 'string', // Replace with your actual refresh token logic
    }, {
      headers: {
        "Content-Type": "application/json-patch+json",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
    });
    localStorage.setItem("access_token", encryptStringBase64(response.data.result.Token_chr));
    // Assuming response.data.result.token_chr is the new access token
    return response.data.result.Token_chr;
  } catch (error) {
    console.error("Error refreshing token:", error);
    throw error;
  }
}

export function serviceCallAuth(requestData) {
  // const dispatch =  useDispatch()
  return new Promise((resolve, reject) => {
    let url = process.env.REACT_APP_BASE_URL +requestData.url;
    let userId = localStorage.userId;
    const request = {
      method: requestData.method || "get",
      headers: {
        "Content-Type": "application/json-patch+json",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
      url: url,
    };
    if (requestData.method === "post" || requestData.method === "put") {
      request["data"] = { ...requestData.data } || {};
    } else {
      request["params"] = { ...requestData.data } || {};
    }
    axios(request)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        // console.log(err.response.status)
        reject(err);
      });
  });
}

export function serviceCallLogin(requestData) {
  // const dispatch =  useDispatch()
  return new Promise((resolve, reject) => {
    let url = requestData.baseUrl;
    let userId = localStorage.userId;
    const request = {
      method: requestData.method || "get",
      headers: {
        "Content-Type": "application/json-patch+json",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
      url: process.env.REACT_APP_BASE_URL+requestData.url
      ,
    };
    if (requestData.method === "post" || requestData.method === "put") {
      request["data"] = { ...requestData.data } || {};
    } else {
      request["params"] = { ...requestData.data } || {};
    }
    axios(request)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        // console.log(err.response.status)
        reject(err);
      });
  });
}
export function serviceCallIdentity(requestData) {
  // const dispatch =  useDispatch()
  return new Promise((resolve, reject) => {
    let url = requestData.baseUrl;
    let userId = localStorage.userId;
    const request = {
      method: requestData.method || "get",
      headers: {
        "Content-Type": "application/json-patch+json",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
      url: process.env.REACT_APP_BASE_URL+requestData.url
      ,
    };
    if (requestData.method === "post" || requestData.method === "put") {
      request["data"] = { ...requestData.data } || {};
    } else {
      request["params"] = { ...requestData.data } || {};
    }
    axios(request)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        // console.log(err.response.status)
        reject(err);
      });
  });
}
export async function serviceCall(requestData) {
  // localStorage.setItem("requestData", requestData);
  let accessToken = await manageAccessToken(localStorage.getItem('access_token'));
 // Prevent API call only if the token is more than 10 minutes past expiration
 if (accessToken === null) {
  // console.error("No valid access token. API call aborted.");
  return; // Or handle it as you prefer
}

  return new Promise(async (resolve, reject) => {
    try {
      let url = process.env.REACT_APP_BASE_URL + requestData.url;

      const request = {
        method: requestData.method || "get",
        headers: {
          Authorization: "Bearer " + accessToken,
          "Content-Type": "application/json-patch+json",
          "Access-Control-Allow-Origin": "*",
          devicetype: "BROWSER",
          "timezone": timeZone,
        },
        url: url,
      };

      if (requestData.method === "post" || requestData.method === "put") {
        request["data"] = { ...requestData.data } || {};
      } else {
        request["params"] = { ...requestData.data } || {};
      }

      const response = await axios(request);
      resolve(response);
    } catch (error) {
     console.error("Error in serviceCall:", error);
      
      // Handle 403 here
      if (error.response?.status === 403) {
        // Show notification or toast
         toast.warn('You do not have permission to access this resource', {
          position: "top-right",
          autoClose: 5000,
        });
         window.location.href = '/';
      }
      
      // Handle 401 here
      if (error.response?.status === 401) {
        toast.warn('Session expired. Please login again');
        localStorage.clear();
        logout(store, signout);
        window.location.href = '/login';
      }
      
      reject(error);
    }
  });
}

export async function serviceCallSendDataArray(requestData) {
  // localStorage.setItem("requestData", requestData);
  let accessToken = await manageAccessToken(localStorage.getItem('access_token'));
 // Prevent API call only if the token is more than 10 minutes past expiration
 if (accessToken === null) {
  // console.error("No valid access token. API call aborted.");
  return; // Or handle it as you prefer
}
  try {
    let url = process.env.REACT_APP_BASE_URL + requestData.url;

    const request = {
      method: requestData.method || "get",
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json-patch+json",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
      url: url,
    };

    if (requestData.method === "post" || requestData.method === "put") {
      request["data"] = requestData.data;
    } else {
      request["params"] = { ...requestData.data } || {};
    }

    const response = await axios(request);
    return response;
  } catch (error) {
    console.error("Error in serviceCallSendDataArray:", error);
          
      // Handle 403 here
      if (error.response?.status === 403) {
        // Show notification or toast
         toast.warn('You do not have permission to access this resource', {
          position: "top-right",
          autoClose: 5000,
        });
         window.location.href = '/';
      }
      
      // Handle 401 here
      if (error.response?.status === 401) {
        toast.warn('Session expired. Please login again');
        localStorage.clear();
        logout(store, signout);
        window.location.href = '/login';
      }
      
    throw error;
  }
}


export async function serviceCallGenerate(requestData) {
  // localStorage.setItem("requestData", requestData);
  let accessToken = await manageAccessToken(localStorage.getItem('access_token'));
 // Prevent API call only if the token is more than 10 minutes past expiration
 if (accessToken === null) {
  // console.error("No valid access token. API call aborted.");
  return; // Or handle it as you prefer
}
  try {
    let url = process.env.REACT_APP_BASE_URL + requestData.url;

    const request = {
      method: requestData.method || "get",
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json-patch+json",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
      url: url,
    };

    if (requestData.method === "post") {
      request["data"] = requestData.data;
    }

    const response = await axios(request);
    return response;
  } catch (error) {
    console.error("Error in serviceCallGenerate:", error);
             
      // Handle 403 here
      if (error.response?.status === 403) {
        // Show notification or toast
         toast.warn('You do not have permission to access this resource', {
          position: "top-right",
          autoClose: 5000,
        });
         window.location.href = '/';
      }
      
      // Handle 401 here
      if (error.response?.status === 401) {
        toast.warn('Session expired. Please login again');
        localStorage.clear();
        logout(store, signout);
        window.location.href = '/login';
      }
      
    throw error;
  }
}


export async function serviceCallPostParms(requestData) {
  // localStorage.setItem("requestData", JSON.stringify(requestData)); // Store requestData as string
  let accessToken = await manageAccessToken(localStorage.getItem('access_token'));
 // Prevent API call only if the token is more than 10 minutes past expiration
 if (accessToken === null) {
  // console.error("No valid access token. API call aborted.");
  return; // Or handle it as you prefer
}
  try {
    let url = process.env.REACT_APP_BASE_URL + requestData.url;

    const request = {
      method: requestData.method || "get",
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json-patch+json",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        timezone: timeZone,
      },
      url: url,
      params: requestData.params || {}, // Pass data as params for all requests
    };

    if (requestData.method === "post" || requestData.method === "put") {
      request.data = { ...requestData.data } || {};
    }

    const response = await axios(request);
    return response;
  } catch (error) {
    console.error("Error in serviceCallPostParms:", error);
    throw error;
  }
}

export async function formDataCommonFunction(formData, url) {
  let accessToken = await manageAccessToken(localStorage.getItem('access_token'));
  // Prevent API call only if the token is more than 10 minutes past expiration
  if (accessToken === null) {
  //  console.error("No valid access token. API call aborted.");
   return; // Or handle it as you prefer
 }
  try {

    const response = await axios.post(process.env.REACT_APP_BASE_URL + url, formData, {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
    });

    return response;
  } catch (error) {
    console.error("Error in formDataCommonFunction:", error);
    throw error;
  }
}


export async function formDataCommonFunctionWithParamsAndBody(formData, url, params) {
  let accessToken = await manageAccessToken(localStorage.getItem('access_token'));
  // Prevent API call only if the token is more than 10 minutes past expiration
  if (accessToken === null) {
  //  console.error("No valid access token. API call aborted.");
   return; // Or handle it as you prefer
 }
  try {

    const response = await axios.post(process.env.REACT_APP_BASE_URL + url, formData, {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
      params: params || {},
    });

    return response;
  } catch (error) {
    console.error("Error in formDataCommonFunctionWithParamsAndBody:", error);
    throw error;
  }
}

export function formDataCommonFunctionUnAuth(formData, baseUrl, url) {
  return new Promise((resolve, reject) => {
    axios
      .post(process.env.REACT_APP_BASE_URL + url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          devicetype: "BROWSER",
          "timezone": timeZone,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}



export async function formDataCommonFunctionPut(formData, baseUrl, url) {
  let accessToken = await manageAccessToken(localStorage.getItem('access_token'));
  // Prevent API call only if the token is more than 10 minutes past expiration
  if (accessToken === null) {
  //  console.error("No valid access token. API call aborted.");
   return; // Or handle it as you prefer
 }
  try {

    const response = await axios.put(process.env.REACT_APP_BASE_URL + url, formData, {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
    });

    return response;
  } catch (error) {
    console.error("Error in formDataCommonFunctionPut:", error);
    throw error;
  }
}

export function formDataFunctionWithoutAuth(formData, baseUrl, url) {
  return new Promise((resolve, reject) => {
    axios
      .post(process.env.REACT_APP_BASE_URL + url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          devicetype: "BROWSER",
          "timezone": timeZone,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error("Error in formDataFunctionWithoutAuth:", error);
        reject(error);
      });
  });
}


export function formDataCommonFunctionPutWithoutAuth(formData, baseUrl, url) {
  return new Promise((resolve, reject) => {
    axios
      .put(process.env.REACT_APP_BASE_URL + url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          devicetype: "BROWSER",
          "timezone": timeZone,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        if (error.response && (error.response.status === 401 || error.response.status === 406)) {
          localStorage.clear();
          window.location.reload();
        } else if (error.response) {
          errorGet(error.response.status);
        } else {
          console.error("Network error:", error.message);
        }
      });
  });
}


export async function gstinCall(requestData) {
  let accessToken = await manageAccessToken(localStorage.getItem('access_token'));
  // Prevent API call only if the token is more than 10 minutes past expiration
  if (accessToken === null) {
  //  console.error("No valid access token. API call aborted.");
   return; // Or handle it as you prefer
 }
  try {
    // localStorage.setItem("requestData", JSON.stringify(requestData));

    let url = genericUrl + requestData.url;

    const request = {
      method: requestData.method || "get",
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json-patch+json",
        "Access-Control-Allow-Origin": "*",
        devicetype: "BROWSER",
        "timezone": timeZone,
      },
      url: url,
    };

    if (requestData.method === "post" || requestData.method === "put") {
      request.data = { ...requestData.data } || {};
    } else {
      request.params = { ...requestData.data } || {};
    }

    const response = await axios(request);
    return response;
  } catch (error) {
    console.error("Error in gstinCall:", error);
    throw error;
  }
}

